import React from "react";
import Body from "./Body";
import Header from "../../Partials/Header/Header";


import Footer from "../../Partials/Footer/Footer";

export default class Standard extends React.Component {
    render() {
        return (
            <div className="integrator-wrapper">
                <Header />
                <Body />
                <Footer />
            </div>
        );
    }
}